// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1RJDZ","right":"styles_right__10ZDu"};